export default class PointOnGeometryLocator {
  locate(p) {}
}
export default class PointOnGeometryLocator {
  locate(p) {}
}
